import {
  getAboutNh as getAboutNhAPI,
  getTermsApp as getTermsAppAPI,
  getWhatToDo,
  getFlashNews as getFlashNewsAPI,
  getAboutMembership as getAboutMembershipAPI
} from '../api/support'
import {
  setAboutMembership,
  setAboutNH,
  setFlashNews,
  setTermsApp,
  setWhatToDos
} from '../state/slices/support_slice'
import { useAppDispatch } from './state'

export const useSupport = () => {
  const dispatch = useAppDispatch()

  const getAboutMembership = async () => {
    const result = await getAboutMembershipAPI()

    if (result.data) {
      dispatch(setAboutMembership(result.data))
    }
  }

  const getAboutNH = async () => {
    const result = await getAboutNhAPI()

    if (result.data) {
      dispatch(setAboutNH(result.data))
    }
  }

  const getTermsApp = async () => {
    const result = await getTermsAppAPI()

    if (result.data) {
      dispatch(setTermsApp(result.data))
    }
  }

  const getWhatToDos = async () => {
    const result = await getWhatToDo()

    if (result.data) {
      dispatch(setWhatToDos(result.data))
    }
  }

  const getFlashNews = async () => {
    const result = await getFlashNewsAPI()

    if (result.data && result.data.flashMessages.length > 0) {
      dispatch(setFlashNews(result.data.flashMessages[0]))
    } else {
      dispatch(setFlashNews(undefined))
    }
  }

  return {
    getAboutMembership,
    getAboutNH,
    getTermsApp,
    getWhatToDos,
    getFlashNews
  }
}

export default useSupport
